import React, { useState, useEffect } from 'react';

import { Button } from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';

import cpaImg from 'images/new_ui/onboarding/example-cpa.png';

import { useContext } from 'components/Members/Onboarding/Context';

import axios from 'axios';

import routes from 'app/routes';

import ExternalLink from 'components/Widgets/ExternalLink';

import { useContext as useUsersContext } from 'components/Users/Context';

export default function TalentAssessmentDownload() {
  const { dispatch, state, actions } = useContext();
  const { state: stateUser } = useUsersContext();

  const [talentAssessment, setTalentAssessment] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.career_pulse_assessment_reports.latest)
      .then((response) => {
        setTalentAssessment(response.data.data);
      });
  }, []);

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  return (
    <div className="content onboarding-content">
      <div className="row">
        <div className="col-lg order-lg-last">

          <img src={cpaImg} style={{ maxWidth: '100%', objectFit: 'cover' }} alt="Example TA" />
        </div>
        <div className="col-lg order-lg-first">
          <div className="pt-4 p-sm-4 pe-lg-0">
            <h1>Congratulations!</h1>
            <p className="mt-3">
              You have completed the first step towards improved Career Success.
            </p>

            <IconWithText
              iconClassName="big-icon onboarding-cpa-download-icon-1 bg-secondary"
              wrapperClassName="mb-3 mt-5"
            >
              <h6>Review your talent assessment report to understand your strengths and discover your blind spots.</h6>
            </IconWithText>

            <IconWithText
              iconClassName="big-icon onboarding-cpa-download-icon-2 bg-secondary"
              wrapperClassName="mb-3"
            >
              <h6>Feel free to discuss the results with your manager or HR business partner.</h6>
            </IconWithText>

            <IconWithText
              iconClassName="big-icon onboarding-cpa-download-icon-3 bg-secondary"
              wrapperClassName="mb-3"
            >
              <h6>Are you ready to move to next step? Build your personalized program and continue your onboarding.</h6>
            </IconWithText>

            <footer className="d-flex justify-content-between mt-5">
              {talentAssessment && stateUser.user && !stateUser.user.attributes.is_mobile_login && (
              <ExternalLink
                variant="outline-primary"
                href={talentAssessment.attributes.url}
              >
                Download Report
              </ExternalLink>
              )}

              <Button onClick={onGoNextClick}>
                Build Program
              </Button>
            </footer>

          </div>
        </div>
      </div>
    </div>
  );
}
